import React from 'react';
import { ReviewsSection } from '../../reviews/ReviewsSection';

interface ProductReviewsProps {
  productId: string;
  shopId?: string;
  partnerId?: string;
}

/**
 * ProductReviews Component
 * Wrapper around ReviewsSection for backward compatibility
 * @deprecated Use ReviewsSection from features/reviews instead
 */
export const ProductReviews: React.FC<ProductReviewsProps> = ({ 
  productId, 
  shopId, 
  partnerId 
}) => {
  return (
    <ReviewsSection
      productId={productId}
      shopId={shopId}
      partnerId={partnerId}
    />
  );
};
